import { ComponentTypes } from "entities/template";
import React from "react";
import { useComponentsConfig } from "../../lib/hooks/useComponentsConfig";
import styles from "./component_badge.module.scss";

interface IComponentBadgeProps {
    type: ComponentTypes,
    onClick: (type: ComponentTypes) => void;
}

export const ComponentBadge: React.FC<IComponentBadgeProps> = React.memo(({
                                                                              type,
                                                                              onClick
                                                                          }) => {
    const componentsConfig = useComponentsConfig();
    const badgeConfig = componentsConfig[type];

    return <div className={styles.container} onClick={() => onClick(type)}>
        <div className={styles.labelBlock}>
            <div className={styles.icon}>
                {badgeConfig.icon}
            </div>
            <div className={styles.labelText}>
                {badgeConfig.label}
            </div>
        </div>
        <div className={styles.subLabelText}>
            {badgeConfig.subLabel}
        </div>
    </div>;
});
